import getCharts from '../getCharts'
import { PatientMedicationCrud } from '../../constants/api.config'

export default async function PatientImagingsCrud(mode, patientID = "-1",data ="", newDate="-1",id="-1") {
    try {
        const payload = { mode, data, patientID,id, newDate }
        const res = await getCharts(PatientMedicationCrud, payload)
        return res.data
    } catch (error) {
        return error
    }
}
